<template>
  <div class="company">
    <HeroText
      :heroH1="$t('company.smallIntro')"
      :heroH2="currentPage.fields.title"
      :heroP="currentPage.fields.intro"
      :internalPage="true"/>
    <!-- Slides -->
    <div
      v-for="(slide, index) of slidesArray"
      :key="index"
      class="internal-page-slide">
      <InternalTitleDescriptionImage
        :srcSetImages="slide.srcSetImages"
        :title="slide.title"
        :description="slide.description"
        :blockquote="slide.blockquote"
        :contentLeft="slide.contentLeft"/>
    </div>
    <InternalNextPages
      :services="true"
      :quality="true"/>
    <glaxiFooter/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import HeroText from '@/components/HeroText/HeroText.vue'
import InternalTitleDescriptionImage from '@/components/InternalTitleDescriptionImage/InternalTitleDescriptionImage.vue'
import InternalNextPages from '@/components/InternalNextPages/InternalNextPages.vue'
import GlaxiFooter from '@/components/GlaxiFooter/GlaxiFooter.vue'

export default {
  name: 'Company',
  components: {
    HeroText,
    InternalTitleDescriptionImage,
    InternalNextPages,
    GlaxiFooter
  },
  props: {
    currentPage: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    slidesArrayIt: [
      {
        srcSetImages: {
          'landscape': require('@/assets/company/yesterday-landscape.jpg'),
          'portrait': require('@/assets/company/yesterday-portrait.jpg')
        },
        title: 'Ieri',
        description: '<p>Tutto inizia negli anni Cinquanta in un forno vicino a Padova. Il signor Serio Galante impara l’arte della panificazione e la coltiva giorno dopo giorno, trasmettendola, fin da subito, anche al figlio Silvio.</p><p>Il forno di Serio diventa un punto di riferimento per tutto il paese. E ben presto lo diventerà per tutto il Nord Italia. Infatti, con l’ingresso ufficiale in azienda di Silvio, nel 1985, il forno di paese, prende una nuova direzione, diventando via via un’industria di panificazione.</p>',
        blockquote: '“Mio padre Serio mi ha trasmesso sin da bambino<br> la passione per questo lavoro, insegnandomi<br> giorno dopo giorno l’arte della panificazione.”',
        contentLeft: true
      },
      {
        srcSetImages: {
          'landscape': require('@/assets/company/today-landscape.jpg'),
          'portrait': require('@/assets/company/today-portrait.jpg')
        },
        title: 'Oggi',
        description: '<p>La dedizione, l’impegno costante e la vocazione della famiglia Galante, ha reso Glaxi Pane una realtà consolidata nel mercato italiano odierno della panificazione surgelata  e proiettata al mercato estero.<br> Oggi siamo in grado di soddisfare le diverse e molteplici richieste di mercato, da quelle più tradizionali alle più innovative.</p><p>Ogni giorno pane per tramezzini, per hamburger e moltissime altre specialità vengono impastati, infornati e congelati per raggiungere bar e ristoranti e regalare tutta la qualità e il gusto del pane appena sfornato.</p><p>E non abbiamo intenzione di fermarci qui. Seguiamo una strada di continua innovazione: nuovi macchinari e servizi che ottimizzano i prodotti e migliorano la condizione  lavorativa dei nostri collaboratori.</p>',
        blockquote: '“Dedizione, impegno costante e vocazione.<br> Seguiamo una strada di continua innovazione.”',
        contentLeft: false
      },
      {
        srcSetImages: {
          'landscape': require('@/assets/company/tomorrow-landscape.jpg'),
          'portrait': require('@/assets/company/tomorrow-portrait.jpg')
        },
        title: 'Domani',
        description: '<p>Il signor Serio ascoltava e cercava di soddisfare sempre le richieste dei clienti della sua bottega.</p><p>Per questo l’azienda ha deciso di investire in un team di ricerca interno dedicato che studia e genera nuove proposte di pane, non solo per rispondere alle esigenze odierne ma anche per anticipare i tempi, creando prodotti all’avanguardia e personalizzati.</p><p>E non ci fermiamo qui! Stiamo lavorando per aprire nuovi canali di vendita e incrementare la nostra presenza nei mercati esteri. E proprio in quest’ottica, si è creata una sinergia vincente con Bassini 1963, produttore di pane e panificati surgelati per il canale GDO. Il gruppo Bassini 1963-Glaxi Pane si propone così come il nuovo punto di riferimento nel settore bakery per i canali GDO e HO.RE.CA, sia sul mercato nazione che internazionale.</p>',
        blockquote: '“Studiamo e generiamo costantemente nuove proposte<br> di pane all’avanguardia e personalizzato.”',
        contentLeft: true
      }
    ],
    slidesArrayEn: [
      {
        srcSetImages: {
          'landscape': require('@/assets/company/yesterday-landscape.jpg'),
          'portrait': require('@/assets/company/yesterday-portrait.jpg')
        },
        title: 'Yesterday',
        description: '<p>It all started in the fifties at a bakery near Padua. Mr. Serio Galante learned the art of baking and continued cultivating it day by day, also passing it down to his son Silvio, right from the start.</p><p>Serio\'s bread shop became a reference point for the whole town. And soon it would become one for all of Northern Italy. In fact, with Silvio\'s official entry into the company, in 1985, the town\'s bakery takes on a new direction, gradually becoming a bread making industry.</p>',
        blockquote: '“Since childhood, my father Serio transmitted<br> his passion for this work to me,<br> day after day, teaching me the art of baking.”',
        contentLeft: true
      },
      {
        srcSetImages: {
          'landscape': require('@/assets/company/today-landscape.jpg'),
          'portrait': require('@/assets/company/today-portrait.jpg')
        },
        title: 'Today',
        description: '<p>The dedication, unwavering commitment and vocation of the Galante family has made Glaxi Pane a well-established business in today\'s Italian market of frozen bakery and has projected it into the foreign market.<br> Today, we are able to meet the market\'s many and varied demands, from the most traditional to the most innovative ones.</p><p> Each day, bread for sandwiches, hamburgers and many other specialities are prepared, baked and frozen so that they can reach bars and restaurants and still have all the quality and taste of freshly baked bread.</p><p> And we have no intention of stopping here. We follow a path of continuous innovation: new machines and services that optimise the products and improve the working conditions of our employees.</p>',
        blockquote: '“Dedication, constant commitment and vocation.<br> We follow a path of continuous innovation.”',
        contentLeft: false
      },
      {
        srcSetImages: {
          'landscape': require('@/assets/company/tomorrow-landscape.jpg'),
          'portrait': require('@/assets/company/tomorrow-portrait.jpg')
        },
        title: 'Tomorrow',
        description: '<p>Mr. Serio Galante has listened to and always done his best to satisfy the demands of his shop\'s clientele. This is why the company decided to invest in a dedicated internal research team that studies and creates new proposals for bread, not only to meet today\'s demands but also to anticipate the times, creating cutting-edge and customised products. And we aren\'t stopping here! We are working on opening new sales channels and increasing our presence in foreign markets.</p><p>And in that sense, we have created a winning synergy with Bassini 1963. manufacturer of bread and frozen bread products for large-scale retail distribution. The Bassini 1963-Glaxi Pane group proposes itself as the new benchmark in the bakery industry for large-scale retail distribution channels and HO.RE.CA, both on the national and international markets.</p>',
        blockquote: '“We study and constantly generate new bread proposals<br> that are at the cutting-edge and customised.”',
        contentLeft: true
      }
    ]
  }),
  computed: {
    ...mapGetters([
      'lang'
    ]),
    slidesArray: {
      get () {
        if (this.lang === undefined) return undefined
        if (this.lang === 'it') return this.slidesArrayIt
        return this.slidesArrayEn
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./style.scss";
</style>
